module.exports = __webpack_public_path__ + "media/video_10.75b26dbd.mp4";